module.exports = __webpack_public_path__ + "img/unknown.bb1106aa.png";